module.exports = __webpack_public_path__ + "img/categorias.50f631e9.png";